module.exports = __webpack_public_path__ + "b8cfd1b7a921bbe7fda1c261e09ee75b.pdf";